import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ChartsService } from '../../../../services/chartService/charts.service';
import { MultiLineChartSpecification } from '../../../../dataModels/data-models';

declare var AmCharts;

@Component({
    moduleId: module.id,
    selector: 'multiple-line-chart',
    templateUrl: 'multipleLineChart.component.html',
    styleUrls: ['multipleLineChart.component.css']
})

export class MultipleLineChart implements OnInit {
    @Input() chartSpecification: MultiLineChartSpecification;
    drawIt: boolean = false;

    constructor(private chartsService: ChartsService) { }

    ngOnInit() {
        setTimeout(() => {
            this.chartsService.notifyMe.subscribe(() => this.drawChart());

            this.drawChart();
        }, 0);
    }

    drawChart() {
        let lineData = this.chartsService.groupByThenSumEachValOfProperty(this.chartSpecification.data,
            this.chartSpecification.xAxis, this.chartSpecification.yAxis, this.chartSpecification.value,
            this.chartSpecification.perYAxisValue);

        lineData = this.chartsService.sortDatesAsc(lineData, 'key');
        this.drawIt = lineData.length > 0 ? true : false;

        let graphs = this.getGraphs();

        setTimeout(() => {
            var chart = AmCharts.makeChart(this.chartSpecification.divId, {
                "type": "serial",
                "theme": "none",
                "mouseWheelZoomEnabled": true,
                "legend": {
                    "useGraphSettings": true,
                    "align": "center"
                },
                "titles": [
                    {
                        "text": this.chartSpecification.title,
                        "size": 15
                    }
                ],
                "dataProvider": lineData,
                "synchronizeGrid": true,
                "valueAxes": [{
                    "id": "v1",
                    "axisColor": "#FF6600",
                    "axisThickness": 2,
                    "gridAlpha": 0,
                    "axisAlpha": 1,
                    "position": "left"
                }],
                "graphs": graphs,
                "chartScrollbar": {},
                "chartCursor": {
                    "cursorPosition": "mouse"
                },
                "categoryField": "key",
                "categoryAxis": {
                    "parseDates": true,
                    "axisColor": "#DADADA",
                    "minorGridEnabled": true
                },
                "export": {
                    "enabled": true,
                    "position": "bottom-right"
                }
            });

            chart.addListener("dataUpdated", zoomChart);
            zoomChart();

            function zoomChart() {
                chart.zoomToIndexes(chart.dataProvider.length - 40, chart.dataProvider.length - 1);
            }
        }, 20);
    }

    getGraphs() {
        let keys = this.chartsService.getValuesOfProperty(this.chartSpecification.data, this.chartSpecification.yAxis);
        let graphs = [];

        for (let i = 0, colorIndex = 0, bulletIndex = 0; i < keys.length; i++ , colorIndex++ , bulletIndex++) {

            colorIndex = colorIndex % this.chartsService.chartColors.length;
            bulletIndex = bulletIndex % this.chartsService.chartbullets.length;

            graphs[i] = {
                "valueAxis": "v1",
                "lineColor": this.chartsService.chartColors[colorIndex],
                "bullet": this.chartsService.chartbullets[bulletIndex],
                "bulletBorderThickness": 1,
                "hideBulletsCount": 30,
                "title": keys[i],
                "valueField": keys[i],
                "fillAlphas": 0,
                "balloonText": keys[i] + ": [[value]]"
            }
        }

        return graphs;
    }

}




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/lineCharts/multipleLineChart/multipleLineChart.component.ts